/**
 * Convert a name to a URL-safe slug.
 * e.g. "Kadebostany" → "kadebostany", "The Band!" → "the-band"
 */
export function nameToSlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Build the URL base for a band.
 * Uses the slug if name is available, falls back to ID.
 */
export function bandUrlBase(bandIdOrSlug: string, bandName?: string): string {
  // bandIdOrSlug can be UUID (legacy) or slug. If bandName proviced, prefer slug.
  const slug = bandName ? nameToSlug(bandName) : '';
  return `/band/${slug || bandIdOrSlug}`;
}

/**
 * Build a URL path for a musician/crew member.
 */
export function memberUrlPath(memberId: string, memberName?: string): string {
  const slug = memberName ? nameToSlug(memberName) : '';
  return slug || memberId;
}

/**
 * Check if a name is unique among a list of items.
 * Returns true if the name (case-insensitive) doesn't exist yet (excluding the item with excludeId).
 */
export function isNameUnique(
  name: string,
  items: { name?: string; id: string }[],
  excludeId?: string,
): boolean {
  const lowerName = name.toLowerCase().trim();
  return !items.some(item =>
    item.id !== excludeId &&
    item.name?.toLowerCase().trim() === lowerName
  );
}

// uniqueSlug REMOVED (audit 2026-10-24 [DEAD]): slugs are server-generated —
// no client caller. (nameToSlug / isNameUnique stay, both actively used.)
